import React, { useMemo } from 'react';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import countries from 'i18n-iso-countries';
import itLocale from 'i18n-iso-countries/langs/it.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(itLocale);
countries.registerLocale(enLocale);

interface Option {
    code: string;
    label: string;
}

interface Props {
    value: string | null | undefined;
    onChange: (code: string | null) => void;
    lang?: string;
    label?: string;
}

type ACProps = AutocompleteProps<Option, false, false, false>;

const NationalityAutocomplete: React.FC<Props> = ({ value, onChange, lang = 'it', label = 'Nationality' }) => {

    const options: Option[] = useMemo(() => {
        const map = countries.getNames(lang, { select: 'official' });
        return Object.entries(map)
            .map(([code, name]) => ({ code, label: name }))
            .sort((a, b) => a.label.localeCompare(b.label, lang));
    }, [lang]);

    const selectedOption = options.find((o) => o.code === value) ?? null;

    const acProps: ACProps = {
        options: options,
        getOptionLabel: (o: Option) => o.label,
        value: selectedOption,
        onChange: (_: React.SyntheticEvent, newVal: Option | null) => {
            onChange(newVal ? newVal.code : null);
        },
        isOptionEqualToValue: (opt: Option, val: Option) => opt.code === val.code,
        renderInput: (params) => React.createElement(TextField, { ...params, label: label, fullWidth: true }),
        noOptionsText: 'Nessun risultato',
        clearText: 'Rimuovi',
        openText: 'Apri',
        closeText: 'Chiudi',
    };

    return React.createElement(Autocomplete, acProps as any);
};

export default NationalityAutocomplete;